module.exports = __webpack_public_path__ + "img/signal_cellular_3_bar-black.5b4e46d9.svg";